import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: REJack
 * id 9CF96408-1A24-4040-AD04-011183CC9ABC
 * name account-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-minus.svg
 * tags
 * - Account / User 
 */
export const AccountMinusIcon = createSvgIcon(<><path d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M1,10V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z" /></>, 'AccountMinusIcon');
export default AccountMinusIcon